/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.NotificationScheduleType_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.NotificationScheduleType domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum NotificationScheduleType_ {
   /// <summary>
   ///   No Schedule (none)
   /// </summary>
   NoSchedule = 0,
   /// <summary>
   ///   Timespan Schedule (time)
   /// </summary>
   TimespanSchedule = 1,
   /// <summary>
   ///   Specific Date (date)
   /// </summary>
   SpecificDate = 2
}

export const NotificationScheduleTypes: NotificationScheduleType[] = [
   {
      code: NotificationScheduleType_.NoSchedule,
      literal: 'NoSchedule',
      description: 'No Schedule',
      shortDescription: 'none',
      listPriority: 0,

      typeName: "NotificationScheduleType"
   },
   {
      code: NotificationScheduleType_.TimespanSchedule,
      literal: 'TimespanSchedule',
      description: 'Timespan Schedule',
      shortDescription: 'time',
      listPriority: 0,

      typeName: "NotificationScheduleType"
   },
   {
      code: NotificationScheduleType_.SpecificDate,
      literal: 'SpecificDate',
      description: 'Specific Date',
      shortDescription: 'date',
      listPriority: 0,

      typeName: "NotificationScheduleType"
   }
]

export class NotificationScheduleType implements IDomainModel {
   code: NotificationScheduleType_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   typeName: string

   static toDomainModel(code: NotificationScheduleType_): NotificationScheduleType {
      return NotificationScheduleTypes.find(d => d.code === code)
   }
}
